<template>
  <div class="index">
    <div class="pc">
        <app-header :oneList= "oneListData"></app-header>
        <div class="centers">
            <div class="content">
                <p class="breadcrumb clearfix">
                    <span class="fl">您的位置： </span>
                    <router-link class="fl" to="/index">科研人才网 > </router-link>
                    <router-link class="fl" to=""> 高端职位</router-link>
                </p>
                <div class="hot commonCss clearfix">
                    <div class="half fl" style="margin-left:0">
                        <h3 class="theTitle"><p class="clearfix"><span class="fl">中高层管理人才</span></p></h3>
                        <router-link v-for="(items,key) in heightList1.slice(0,15)"  target="_blank" :to="{path:'/jobDetail',query:{jobDetailId:items.recruitId}}"  :key="key" class="clearfix">
                            <span class="circle fl"></span>
                            <span class="title fl">{{items.title}}</span>
                        </router-link>
                        <p class="more" v-if="heightList1.length>=15"><router-link  :to="{path:'/moreList',query:{parentUrl:'/expert',childName:'中高层管理人才',parentName:'高端职位',categoryCode:'zhong_gao_ceng_guan_li'}}">查看更多>></router-link></p>
                    </div>
                    <!-- <div class="half fl">
                        <h3 class="theTitle"><p class="clearfix"><span class="fl">博后进站</span></p></h3>
                        <router-link v-for="(items,key) in heightList2.slice(0,10)"  target="_blank" :to="{path:'/jobDetail',query:{jobDetailId:items.recruitId}}"  :key="key" class="clearfix">
                            <span class="circle fl"></span>
                            <span class="title fl">{{items.title}}</span>
                        </router-link>
                        <p class="more" v-if="heightList2.length>=15"><router-link :to="{path:'/moreList',query:{parentUrl:'/expert',childName:'博后进站',parentName:'高端职位',categoryCode:'te_ping_zhuan_jia'}}">查看更多>></router-link></p>
                    </div> -->
                    <div class="half fl">
                        <h3 class="theTitle"><p class="clearfix"><span class="fl">学术带头人</span></p></h3>
                        <router-link v-for="(items,key) in heightList3.slice(0,10)"  target="_blank" :to="{path:'/jobDetail',query:{jobDetailId:items.recruitId}}"  :key="key" class="clearfix">
                            <span class="circle fl"></span>
                            <span class="title fl">{{items.title}}</span>
                        </router-link>
                        <p class="more" v-if="heightList3.length>=15"><router-link :to="{path:'/moreList',query:{parentUrl:'/expert',childName:'学术带头人',parentName:'高端职位',categoryCode:'xue_shu_dai_tou_ren'}}">查看更多>></router-link></p>
                    </div>
                </div>
            </div>
            
        </div>
        <app-ad :fiveListData = "threeList"></app-ad>
        <app-al :fiveListData = "threeList"></app-al>
        <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import {get, postWithJson, form} from '@/api/services'
import AppFooter from '../../components/common/footer.vue'
import AppHeader from '../../components/common/header2.vue'
import AppAd from '../../components/common/addif.vue'
import AppAl from '../../components/common/addil.vue'
export default {
    components: { AppFooter,AppHeader, AppAd, AppAl},
    name: 'city',
    data () {
        return {
            oneListData:{},
            threeList:"",
            twoList:"",
            heightList1:"",
            heightList2:"",
            heightList3:"",
            heightList4:"",

            // dynamicTitle1:"",
            // dynamicTitle2:"",
            // dynamicTitle3:"",
            // dynamicTitle4:"",
            // dynamicTitle5:"",
            // dynamicTitle6:"",
            // dynamicTitle7:"",
            // dynamicTitle8:"",
            // dynamicTitle9:"",

            // navigationList1:'',
            // navigationList2:'',
            // navigationList3:'',
            // navigationList4:'',
            // navigationList5:'',            
        }
    },
    created:function(){
        this.search();
        // this.getTitleList();
    },
    methods:{
        search(){  // 搜索
            let _self = this;
            
            var reqData = {categoryCode:100} 
            postWithJson('front/advertises/getAdvertisesList',reqData).then(
                function(response) {
                    if(response.data.status){
                        if(response.data.data){
                            let resData = response.data.data;
                            _self.oneListData = resData[1];
                            _self.threeList = resData[5];
                        }
                    }else{
                        console.log(response.data.message); 
                    }
                },
                function(response) {
                   _self.$message({
                        message: response.data.message,
                        type: 'error'
                    });           
                }
                
            );

            let reqData1 = {
                city:"",
                province:'',
                dictCode:'',
                companyId:'',
                desc:"",
                keyWord:'',
                categoryCode:"zhong_gao_ceng_guan_li"
            }
            postWithJson('front/recruit/queryRecruit?pageNum=1&pageSize=15',reqData1).then(
                function(response){
                    if(response.data.status){
                        _self.heightList1 = response.data.data;
                    }else{
                        console.log(response.data.message);
                    }
                },
                function(response){
                    _self.$message({
                        message: "请重试",
                        type: 'error'
                    });
                }
            )
            let reqData2 = {
                city:"",
                province:'',
                dictCode:'',
                companyId:'',
                desc:"",
                keyWord:'',
                categoryCode:"te_ping_zhuan_jia"
            }
            postWithJson('front/recruit/queryRecruit?pageNum=1&pageSize=15',reqData2).then(
                function(response){
                    if(response.data.status){
                        _self.heightList2 = response.data.data;
                    }else{
                        console.log(response.data.message);
                    }
                },
                function(response){
                    _self.$message({
                        message: "请重试",
                        type: 'error'
                    });
                }
            )
            let reqData3 = {
                city:"",
                province:'',
                dictCode:'',
                companyId:'',
                desc:"",
                keyWord:'',
                categoryCode:"xue_shu_dai_tou_ren"
            }
            postWithJson('front/recruit/queryRecruit?pageNum=1&pageSize=12',reqData3).then(
                function(response){
                    if(response.data.status){
                        _self.heightList3 = response.data.data;
                    }else{
                        console.log(response.data.message);
                    }
                },
                function(response){
                    _self.$message({
                        message: "请重试",
                        type: 'error'
                    });
                }
            )
            get('front/dict/getDict',{dictType:'zhuan_jia_er_ji_fen_lei'}).then(
				function(response) {
					if(response.data.status){
						_self.categoryList = response.data.data;
					}else{
						console.log(response.data.message);
					}
				},
				function(response) {
					_self.$message({
                        message: response.data.message,
                        type: 'error'
                    });            
				}
            )
            
            
        },
    }
}
</script>

<style scoped = "scoped"  lang = "less">
.pc{
    background-color: #f4f4f4;
    .header{
        background-color: #fff;
        /* overflow: hidden; */
        .container{
            width: 1200px;
            margin: 0 auto;
            h3{
                height: 20px;
                line-height: 20px;
                font-size:12px;
                font-family:PingFangSC-Regular;
                font-weight:400;
                margin: 10px 0;
                .titles{
                    font-size:14px;
                    font-family:PingFangSC-Semibold;
                    font-weight:600;
                    color:rgba(23,135,251,1);
                    height:20px;
                    font-weight:bold;
                    line-height:20px;
                    img{
                        margin-right: 6px;
                        margin-top: 2px;
                    }
                }
                a{
                    color:rgba(51,51,51,1);
                    margin: 6px;
                }
            }
            .threee{
                a{
                    margin-left: 10px;
                }
                img{
                    width:393px;
                    height: 50px;
                    display: block;
                }
                a:first-child{
                    margin-left: 0;
                }
            }
            .one{
                margin-top: 10px;
                img{
                    display: block;
                    width: 1200px;
                    height: 50px;
                }
            }
            .searchBar{
                margin: 24px 0 20px;
                p{
                    display: inline-block;
                    margin-left: 30px;
                    input{
                       width: 544px;
                       height: 56px; 
                       box-sizing: border-box;
                       text-indent: 20px;
                       font-size: 16px;
                    }
                    img{
                        cursor: pointer;
                    }
                }
                a{
                    img{
                        margin-left: 10px;
                        display: block;
                    }
                }
                .changeCity{
                    margin-left: 30px;
                    margin-top: 8px;
                    height: 40px;
                    line-height: 40px;
                    border-left: 1px solid #E5E5E5;
                    span{
                        font-size:28px;
                        font-family:PingFangSC-Medium;
                        font-weight:500;
                        color: #1787FB;
                        margin-left: 20px;
                    }
                    i{
                        margin-left: 12px;
                        font-size:14px;
                        font-family:PingFangSC-Regular;
                        font-weight:400;
                        color: #999;
                        display: inline-block;
                        height: 14px;
                        line-height: 14px;
                        font-style: normal;
                        margin-top: 16px;
                        cursor: pointer;
                    }
                }
            }
            .navs{
                width:1200px;
                height:50px;
                line-height: 50px;
                background:rgba(23,135,251,1);
                padding: 0 40px;
                box-sizing: border-box;
                a{
                    font-family:PingFangSC-Semibold;
                    font-weight:600;
                    color:rgba(255,255,255,1);
                    box-sizing: border-box;
                    font-size: 16px;
                    padding: 0 4px;
                    height: 40px;
                    line-height: 40px;
                    margin-top: 6px;
                    margin-left: 25px;
                }
                a:first-child{
                    margin-left: 0;
                }
                a:nth-child(2){
                    border-bottom: 4px solid #fff;
                }
            }
        }
          
    }
    .centers{
        .content{
            width: 1200px;
            margin: 0 auto 50px;
            overflow: hidden;
           .breadcrumb{
                margin: 16px 0 20px;
                font-size:14px;
                font-family:PingFangSC-Regular;
                font-weight:400;
                color:rgba(51,51,51,1);
                a{
                  color:rgba(51,51,51,1); 
                  margin-left: 4px; 
                }
           }
           .tops{
               .new{
                   height: 70px;
                   background-color: white;
                   margin-bottom: 20px;
                   position: relative;
                   .left{
                       position: absolute;
                       left: 0;
                       top: 0;
                       height: 100%;
                       display: inline-block;
                       width: 20px;
                       color: #4F7C87;
                       background-color: #D1DAE1;
                       padding-top: 14px;
                       text-align: center;
                       font-size: 14px;
                   }
                   .left i{
                       position: absolute;
                       right: -10px;
                       top: 24px;
                       width: 0;
                       height: 0;
                       border-left: 10px solid #D1DAE1;
                       border-top: 10px solid transparent;
                       border-bottom: 10px solid transparent;
                   }
                   .right{
                       position: absolute;
                       right: 0;
                       top: 0;
                       height: 100%;
                       display: inline-block;
                       width: 20px;
                       color: #4F7C87;
                       background-color: #D1DAE1;
                       padding-top: 14px;
                       text-align: center;
                       font-size: 14px;
                   }
                    .center{
                        margin-left: 30px;
                        overflow: hidden;
                        ul{
                            width: 300000px;
                            margin: 8px 0;
                        }
                        a{
                            color: #4F7C87;
                            font-size: 15px;
                        }
                        li{
                            margin-left: 40px;
                        }
                        li:first-child{
                            margin-left: 0;
                        }
                        .animate{
                            /* padding-left: 20px; */
                            font-size: 12px;
                            color: #000;
                            /* display: inline-block; */
                            white-space: nowrap;
                            animation: 600s wordsLoop linear infinite normal;
                        }
                        .animate:hover{
                            -webkit-animation-play-state: paused;
                            animation-play-state: paused;
                        }
                        @keyframes wordsLoop {
                            0% {
                                transform: translateX(0px);
                                -webkit-transform: translateX(0px);
                            }
                            100% {
                                transform: translateX(-10000px);
                                -webkit-transform: translateX(-10000px);
                            }
                        }
                
                        @-webkit-keyframes wordsLoop {
                            0% {
                                transform: translateX(0);
                                -webkit-transform: translateX(0);
                            }
                            100% {
                                transform: translateX(-100%);
                                -webkit-transform: translateX(-100%);
                            }
                        }
                    }
               }
               .subject{
                   height: 60px;
                   line-height: 60px;
                   background-color: white;
                   li{
                       padding: 0 32px;
                       font-size: 16px;
                       color:#666;
                       cursor: pointer;
                   }
                   li:hover{
                       color: #1787FB;
                   }
               }
           }
            .comList{
                margin-top: 10px;
                a{
                    width: 232px;
                    background-color: white;
                    border:1px solid rgba(226,226,226,1);
                    box-sizing: border-box;
                    overflow: hidden;
                    text-align: center;
                    margin-left: 9px;
                    margin-top: 10px;
                    img{
                        display: block;
                        width: 232px;
                        height: 70px;
                    }
                    p{
                        text-align: center;
                        height: 28px;
                        line-height: 28px;
                        width: 232px;
                        overflow: hidden;    
                        text-overflow:ellipsis;    
                        white-space: nowrap;
                        font-size:14px;
                        font-family:PingFangSC-Regular;
                        font-weight:400;
                        color:rgba(50,95,134,1);
                        border-top:1px solid rgba(226,226,226,1);
                    }
                }
                a:hover{
                    -webkit-box-shadow: 0 15px 30px rgba(0,0,0,0.2);    /*添加阴影*/
                    box-shadow: 0 15px 30px rgba(0,0,0,0.2);
                    -webkit-transform: translate3d(0, -2px, 0);     /*向上浮动*/
                    transform: translate3d(0, -2px, 0);
                    p{
                        color: #1787fb;
                    }
                }
                a:nth-child(5n+1){
                    margin-left: 0px;
                }
            }
            .commonCss{
                .half{
                    margin-top: 20px;
                    background-color: white;
                    border:1px solid rgba(229,229,229,1);
                    padding: 10px;
                    margin-left: 10px;
                    height: 600px;
                    .theTitle{
                        height: 45px;
                        border-bottom: 1px solid #E2E2E2;
                        margin-bottom: 10px;
                        p{
                            display: inline-block;
                            padding-right: 6px;
                            height: 45px;
                            border-bottom: 4px solid #1787FB;
                            line-height: 42px;
                            img{
                                margin-top: 10px;
                                margin-right: 4px;
                                height: 20px;
                                width: 20px;
                            }
                        }
                        .titleRight{
                            border-bottom: none;
                            height: 45px;
                            line-height: 45px;
                            color: #1787FB;
                        }
                    }
                    a{
                        height: 32px;
                        line-height: 32px;
                        border-bottom: 1px dashed #D1D1D1;
                        font-size:14px;
                        font-family:PingFangSC-Semibold;
                        font-weight:600;
                        display: block;
                        .circle{
                            display: inline-block;
                            border-radius: 50%;
                            width:6px;
                            height:6px;
                            background:rgba(23,135,251,1);
                            margin-right: 6px;
                            margin-top: 12px;
                        }
                        .topping{
                            color: #EE6464;
                        }
                        .title{
                            color: #333;
                            display: inline-block;
                            width: 368px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                        .detail{
                            margin-right: 10px;
                            font-size:14px;
                            font-family:PingFangSC-Regular;
                            font-weight:400;
                            color:rgba(23,135,251,1);
                            font-style: normal;
                        }
                    }
                    a:hover{
                        .title{
                            color:rgba(23,135,251,1);
                        }
                    }
                    .more{
                        margin-top: 16px;
                        a{
                            border-bottom: none;
                            text-align: center;
                            font-size:12px;
                            font-family:PingFangSC-Regular;
                            font-weight:400;
                            color:rgba(23,135,251,1);
                        }
                    }
                }
            }
            .hot{
                .half{
                    width: 594px;
                    a{
                        .title{
                            width: 550px;
                        }
                    }
                }
                
            }
            .university{
                .commonLeft{
                    width: 950px;
                    overflow: hidden;
                    .half{
                        margin-left: 0;
                        a{
                            .title{
                                width: 430px;
                            }
                        }

                    }
                    .half:nth-child(2n){
                        margin-left: 10px;
                    }
                }
                .commonRight{
                    width: 240px;
                    overflow: hidden;
                }
                .half{
                    width: 470px;
                    height: 410px;
                    padding-bottom: 20px;
                    a{
                        .title{
                            width: 324px;
                        }
                    }
                }
                .navigation{
                    background-color: white;
                    width: 240px;
                    height: 410px;
                    margin-top: 20px;
                    padding: 10px 20px;
                    .theTitle{
                        height: 45px;
                        border-bottom: 1px solid #E2E2E2;
                        p{
                            display: inline-block;
                            padding-right: 6px;
                            height: 45px;
                            border-bottom: 4px solid #1787FB;
                            line-height: 42px;
                            img{
                                margin-top: 14px;
                                margin-right: 4px;
                            }
                        }
                        
                    }
                    ul{
                        border: 1px solid #CBDFF3;
                        margin-top: 20px;
                        li{
                            border-bottom: 1px solid #CBDFF3;
                            height: 64px;
                            line-height: 64px;
                            a{
                                display: block;
                                height: 100%;
                                img{
                                    margin: 18px 15px 0 30px;
                                }
                                span{
                                    color: #1787FB;
                                }
                            }
                        }
                        li:nth-child(2n){
                            background-color: rgba(245,248,252,1);
                        }
                        li:last-child{
                            border-bottom: none;
                        }
                    }
                }
                .cityList{
                    background-color: white;
                    width: 240px;
                    /* height: 570px; */
                    margin-top: 20px;
                    padding: 10px 20px 24px;
                    .theTitle{
                        height: 45px;
                        border-bottom: 1px solid #E2E2E2;
                        p{
                            display: inline-block;
                            padding-right: 6px;
                            height: 45px;
                            border-bottom: 4px solid #1787FB;
                            line-height: 42px;
                            img{
                                margin-top: 14px;
                                margin-right: 4px;
                            }
                        }
                        
                    }
                    ul{
                        border: 1px solid #CBDFF3;
                        margin-top: 20px;
                        li{
                            border-bottom: 1px solid #CBDFF3;
                            height: 40px;
                            line-height: 40px;
                            width: 33.333%;
                            a{
                                display: inline-block;
                                width: 100%;
                                height: 100%;
                                text-align: center;
                                font-size: 14px;
                                color: #333333;
                            }
                        }
                        /* li:hover{
                            background-color: rgba(245,248,252,1);
                        } */
                        li:nth-child(6n){
                            background-color: rgba(245,248,252,1);
                        }
                        li:nth-child(6n-1){
                            background-color: rgba(245,248,252,1);
                        }
                        li:nth-child(6n-2){
                            background-color: rgba(245,248,252,1);
                        }
                        li:last-child{
                            border-bottom: none;
                        }
                    }
                }
            }
        }
    }


    .footer{
        margin-top: 70px;
        .footer_top{
            text-align: center;
            background-color: #4E4E4E;
            color: #8F8F8F;
            height: 50px;
            line-height: 50px;
            vertical-align: middle;
            a{
                color: #8F8F8F;
                margin: 0 10px;
                font-size: 12px;
                vertical-align: middle;
            }
        }
        .footer_bottom{
            text-align: center;
            background-color: #303030;
            color: #8F8F8F;
            height: 190px;
            padding-top: 18px;
            font-weight:400;
            font-family:PingFangSC-Regular;
            font-size:12px;
            p{
                line-height:22px
            }
        }
          
    }
    
}
 @media all and (max-width: 768px) {
    .pc .centers .content{
        width: 100%;
    }
    .pc .centers .content .hot .half{
        width: 100%;
    }
    .detail{
        display: none;
    }
    .pc .centers .content .hot .half a .title{
        width: 96%;
    }
    .pc .centers .content .commonCss .half{
        margin-left: 0;
    }
}
</style>





// WEBPACK FOOTER //
// src/views/classify/expert.vue